import React, { useState } from 'react';
import { useMutation } from 'react-query';
import { Alert, Col, Form, Modal, Row, Spin } from 'antd';
import moment from 'moment';

import { ExportsForm as ExportsFormInner } from './components/ExportsForm';

import { createReport } from '../../requests/exportRequests';
import { getBlobUrl } from '../../../../helpers/getBlobUrl';
import { downloadFile } from '../../../../helpers/downloadFile';
import { HourGlassSpinIndicator } from '../../../../components/SpinIndicators/HourGlassSpinIndicator';
import { useNavigationBlocker } from '../../../../hooks/useNavigationBlocker';

const ExportsForm = Form.create({ name: 'exports' })(ExportsFormInner);

export const ExportsPage = () => {
  // const currentCompany = useSelector(
  //   (state) => state.housingStockStore.currentCompany
  // );
  const createReportMutation = useMutation(
    ({ url, reportParams }) => createReport(url, reportParams),
    {
      onSuccess(responseData, values) {
        if (!responseData) {
          return;
        }
        const { name, extension } = values;
        const url = getBlobUrl(responseData, extension);
        const dateTime = moment().utc().format('DD_MM_YYYY HH_mm_ss');
        downloadFile({ url, fileName: `${name} (${dateTime}).${extension}` });
      },
    }
  );

  const onSubmit = ({ reportParams, selectedType }) => {
    const { extension, name, url } = selectedType;
    createReportMutation.mutate({
      url,
      name,
      extension,
      reportParams,
    });
  };

  const [formHasData, setFormHasReportParams] = useState(false);

  const isBlocking = createReportMutation.isLoading || formHasData;

  useNavigationBlocker(isBlocking, ({ location, unblock, history }) => {
    Modal.confirm({
      title: 'Вы уверены, что хотите покинуть страницу "Отчеты" ?',
      content: 'Введенные вами данные будут потеряны.',
      okText: 'Да',
      cancelText: 'Нет',
      onOk: () => {
        unblock();
        history.push(location);
      },
      onCancel: () => {},
    });
  });

  return (
    <Col style={{ padding: '10px' }}>
      <Row>
        <Col align="center">
          <Alert
            type="info"
            description={<h3>На данной странице вы можете создать отчет.</h3>}
          />
        </Col>
      </Row>
      <Row style={{ marginTop: '20px' }}>
        <Col>
          <Spin
            spinning={Boolean(createReportMutation?.isLoading)}
            indicator={<HourGlassSpinIndicator />}
            tip={'Подождите, отчет создается'}
          >
            <ExportsForm
              // companyId={currentCompany?.id}
              onSubmit={onSubmit}
              isCreateLoading={createReportMutation.isLoading}
              setFormHasReportParams={setFormHasReportParams}
            />
          </Spin>
        </Col>
      </Row>
    </Col>
  );
};

ExportsPage.propTypes = {};
